import { useEffect } from "react";
import { Footer } from "@/components/lunar/Footer";
import { PillsHeader } from "@/components/venue/VenueHero";
import { EventsHero } from "@/components/events/EventsHero";
import { EventsHow } from "@/components/events/EventsHow";
import { EventTypes } from "@/components/events/EventTypes";
import {
    EventsRemembers,
    EventsBuilt,
    EventsClosing,
} from "@/components/events/EventsSections";

export default function Events() {
    useEffect(() => {
        document.title = "Lunar Event Activation — Lunar";
        return () => {
            document.title = "Lunar — The social network for real life";
        };
    }, []);

    const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    const toEnquiry = () => scrollTo("events-enquiry");

    return (
        <div data-testid="events-page">
            <PillsHeader
                links={[
                    { label: "For venues", href: "/venue-kit", testId: "pills-header-venues" },
                    { label: "Network", href: "/networking", testId: "pills-header-network" },
                    { label: "Safety →", href: "/safety", testId: "pills-header-safety" },
                ]}
            />
            <main>
                <EventsHero onPrimary={toEnquiry} onSecondary={() => scrollTo("events-how")} />
                <EventsHow />
                <EventTypes />
                <EventsRemembers />
                <EventsBuilt onCta={toEnquiry} />
                <EventsClosing />
            </main>
            <Footer />
        </div>
    );
}
